<template>
  <div class="actions-partial">
    <button class="btn btn-sm btn-outline-secondary" title="Detalle de la norma" @click="handleWatch(data.id)">
      Detalle
    </button>

    <button v-if="$validPermission('NORM')" class="btn btn-sm btn-outline-primary" title="Detalle de la norma" @click="handleEdit">
      Actualizar
    </button>
  </div>
</template>
<script>
export default {
  name: "search-partials-actions",
  props: {
    showEditProp: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  methods: {
    handleWatch: function (item) {
      var arg = [];
      arg['id'] = item;
      Vue.prototype.$eventHub.$emit('toggleSidebarClick', 'Detalle norma', 'processes-detail-process-task-rule-detail-view', arg, 'mw-100');
    },
    handleEdit: function() {
      Vue.prototype.$eventHub.$emit('toggleSidebarClick', 'Editar norma', 'edit-rule', this.data);
    }
  },
};
</script>